import { render } from "./AttrLinkOdoo.vue?vue&type=template&id=7f9c2637&scoped=true"
import script from "./AttrLinkOdoo.vue?vue&type=script&lang=js"
export * from "./AttrLinkOdoo.vue?vue&type=script&lang=js"

import "./AttrLinkOdoo.vue?vue&type=style&index=0&id=7f9c2637&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9c2637"],['__file',"src/components/widgets/components_core/AttrLinkOdoo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f9c2637"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f9c2637', __exports__)) {
    api.reload('7f9c2637', __exports__)
  }
  
  module.hot.accept("./AttrLinkOdoo.vue?vue&type=template&id=7f9c2637&scoped=true", () => {
    api.rerender('7f9c2637', render)
  })

}


export default __exports__